module.exports = __webpack_public_path__ + "img/co3.ea94147b.png";